/* TypeScript file generated from InputSearch.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as InputSearchJS from './InputSearch.res.js';

import type {domProps as JsxDOM_domProps} from '../../../src/shims/JsxDOM.shim';

export type props<loading,onRequestClear,disabled,bordered,focused,placeholder,autoFocus,containerRef,inputRef,ariaProps,value,onChange,onFocus,onBlur> = {
  readonly loading: loading; 
  readonly onRequestClear: onRequestClear; 
  readonly disabled?: disabled; 
  readonly bordered?: bordered; 
  readonly focused?: focused; 
  readonly placeholder?: placeholder; 
  readonly autoFocus?: autoFocus; 
  readonly containerRef?: containerRef; 
  readonly inputRef?: inputRef; 
  readonly ariaProps?: ariaProps; 
  readonly value?: value; 
  readonly onChange?: onChange; 
  readonly onFocus?: onFocus; 
  readonly onBlur?: onBlur
};

export const make: React.ComponentType<{
  readonly loading: boolean; 
  readonly onRequestClear: () => void; 
  readonly disabled?: boolean; 
  readonly bordered?: boolean; 
  readonly focused?: boolean; 
  readonly placeholder?: string; 
  readonly autoFocus?: boolean; 
  readonly containerRef?: any; 
  readonly inputRef?: any; 
  readonly ariaProps?: JsxDOM_domProps; 
  readonly value?: string; 
  readonly onChange?: (_1:string) => void; 
  readonly onFocus?: () => void; 
  readonly onBlur?: () => void
}> = InputSearchJS.make as any;
